import { FormFieldDefinition } from '../types';

export const getFieldKey = <T extends string>(
  field: FormFieldDefinition<T>,
  index: number,
) => {
  return field.type !== 'spacer' ? field.name : `field${index}`;
};
